<div style="min-height: calc(100vh - 391px)">
    <div *ngIf="matrixList?.length">
        <mat-accordion multi="false" class="informate-expansion-wrapper informate-matrix-expansion-wrapper">
            <ng-container *ngFor="let matrix of matrixList; let i = index">
                <mat-expansion-panel
                    (opened)="showPanel(matrix.userMatrixId)"
                    (opened)="(expanded)"
                    (closed)="hidePanel()"
                    [hideToggle]="true"
                    #matrixExpansionPanel
                >
                    <mat-expansion-panel-header *ngIf="matrix">
                        <mat-panel-title style="width: 100%">
                            {{ matrix.name }}
                        </mat-panel-title>
                        <mat-panel-description>
                            <app-matrix-modify
                                [userMatrixId]="matrix.userMatrixId"
                                [userMetrixName]="matrix.name"
                                (refreshMatrix)="userActionHandler($event)"
                                (modelOpen)="openfolder($event)"
                                (click)="openModify($event)"
                            ></app-matrix-modify>
                            <app-matrix-remove
                                [userMatrixId]="matrix.userMatrixId"
                                (refreshMatrix)="userActionHandler($event)"
                                (click)="deleteHandler($event)"
                            ></app-matrix-remove>
                            <mat-icon *ngIf="!matrixExpansionPanel.expanded">
                                <a
                                    href="javascript:void(0)"
                                    class="edit_icon"
                                    (click)="(matrix.userMatrixId)"
                                    #tooltip="matTooltip"
                                    matTooltip="Expand"
                                    [matTooltipPosition]="tooltip_position"
                                >
                                    expand_more
                                </a>
                            </mat-icon>
                            <mat-icon *ngIf="matrixExpansionPanel.expanded">
                                <a
                                    href="javascript:void(0)"
                                    class="edit_icon"
                                    (click)="hidePanel()"
                                    #tooltip="matTooltip"
                                    matTooltip="Hide"
                                    [matTooltipPosition]="tooltip_position"
                                >
                                    expand_less
                                </a>
                            </mat-icon>
                        </mat-panel-description>
                    </mat-expansion-panel-header>

                    <app-matrix-sorting *ngIf="matrixRowData" (refreshMatrix1)="userActionHandler($event)" [data]="matrixRowData"> </app-matrix-sorting>
                </mat-expansion-panel>
            </ng-container>
        </mat-accordion>
    </div>

    <div class="d-flex justify-content-center align-items-center h-100" style="color: #ccc; min-height: calc(100vh - 391px)" *ngIf="!matrixList?.length">
        <h1>No data available to display. Plaese use 'Add New Metrix' to add new data.</h1>
    </div>
</div>
